module.exports = __webpack_public_path__ + "static/media/RNSSanz-SemiBold.887ee7c2.otf";